var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"poster-wrapper",class:{small: _vm.small, medium: _vm.medium, full: _vm.full},staticStyle:{"opacity":"0.6"},attrs:{"title":_vm.$t('previewAvailableSoon')}},[(_vm.ctype === 'radio' || _vm.ctype === 'closingtime')?_c('v-layout',{attrs:{"row":"","justify-center":"","nowrap":""}},[(_vm.closingtime)?_c('v-icon',{style:({
          'font-size': _vm.previewIconSize + 'em',
          width: _vm.previewWidth + 'px',
          height: _vm.previewHeight + 'px',
        })},[_vm._v("\n        campaign\n      ")]):_c('span',[_c('v-img',{attrs:{"src":"/static/radiospot_play_button.svg","width":_vm.previewWidth,"cover":""}})],1)],1):_vm._e(),_vm._v(" "),(_vm.ctype === 'tv')?_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[(_vm.showTvAsText)?_c('v-subheader',{staticClass:"text-xs-center",class:{
          caption: _vm.$vuetify.breakpoint.xs,
          subheading: _vm.$vuetify.breakpoint.smAndUp,
        },staticStyle:{"user-select":"none"}},[_vm._v("\n        "+_vm._s(_vm.$t('previewAvailableSoon'))+"\n      ")]):_c('v-icon',{style:({
          'font-size': _vm.previewIconSize - 0.75 + 'em',
          width: _vm.previewWidth + 'px',
          height: _vm.previewHeight + 'px',
        })},[_vm._v("\n        tv\n      ")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MiniPreviewUnprocessed.vue?vue&type=template&id=bb7a113e&scoped=true&
// module id = 1773
// module chunks = 5